import PropTypes from 'prop-types';

export const Icons = ({ className = '', variant }) => {
  const renderIcon = () => {
    switch (variant) {
      case Icons.OPEN:
        return (
          <svg
            width="46"
            height="54"
            viewBox="0 0 46 54"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_dddd_72473_44681)">
              <rect x="5" y="1" width="36" height="36" rx="12" fill="white" />
              <rect
                x="5.75"
                y="1.75"
                width="34.5"
                height="34.5"
                rx="11.25"
                stroke="url(#paint0_linear_72473_44681)"
                strokeWidth="1.5"
              />
              <g clipPath="url(#clip0_72473_44681)">
                <path
                  d="M21.5051 22.152V21.9858C21.5093 21.2145 21.5818 20.6009 21.7224 20.1449C21.8673 19.6889 22.0718 19.3224 22.336 19.0455C22.6002 18.7642 22.922 18.5064 23.3012 18.272C23.5612 18.1101 23.7934 17.9332 23.998 17.7415C24.2068 17.5455 24.3708 17.3281 24.4901 17.0895C24.6095 16.8466 24.6691 16.576 24.6691 16.2777C24.6691 15.9411 24.5903 15.6491 24.4326 15.402C24.2749 15.1548 24.0619 14.9631 23.7934 14.8267C23.5292 14.6903 23.233 14.6222 22.9049 14.6222C22.6024 14.6222 22.3147 14.6882 22.042 14.8203C21.7735 14.9482 21.5498 15.1442 21.3708 15.4084C21.1961 15.6683 21.0981 15.9986 21.0768 16.3991H18.8012C18.8225 15.5895 19.0186 14.9119 19.3893 14.3665C19.7643 13.821 20.2586 13.4119 20.8722 13.1392C21.4901 12.8665 22.172 12.7301 22.9177 12.7301C23.7316 12.7301 24.4475 12.8729 25.0654 13.1584C25.6876 13.4439 26.1713 13.8509 26.5164 14.3793C26.8659 14.9034 27.0406 15.5256 27.0406 16.2457C27.0406 16.7315 26.9617 17.1662 26.8041 17.5497C26.6507 17.9332 26.4312 18.2741 26.1457 18.5724C25.8602 18.8707 25.5214 19.1371 25.1294 19.3714C24.7842 19.5845 24.5008 19.8061 24.2792 20.0362C24.0619 20.2663 23.8999 20.5369 23.7934 20.848C23.6911 21.1548 23.6379 21.5341 23.6336 21.9858V22.152H21.5051ZM22.6173 26.1406C22.2338 26.1406 21.9035 26.0043 21.6265 25.7315C21.3495 25.4588 21.211 25.1264 21.211 24.7344C21.211 24.3509 21.3495 24.0227 21.6265 23.75C21.9035 23.4773 22.2338 23.3409 22.6173 23.3409C22.9965 23.3409 23.3247 23.4773 23.6017 23.75C23.8829 24.0227 24.0235 24.3509 24.0235 24.7344C24.0235 24.9943 23.9575 25.2308 23.8254 25.4439C23.6975 25.657 23.5271 25.8274 23.314 25.9553C23.1052 26.0788 22.873 26.1406 22.6173 26.1406Z"
                  fill="#262626"
                />
              </g>
            </g>
            <defs>
              <filter
                id="filter0_dddd_72473_44681"
                x="-1.92308"
                y="-5.92308"
                width="49.8462"
                height="59.5385"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="0.692308" />
                <feGaussianBlur stdDeviation="0.692308" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.631373 0 0 0 0 0.631373 0 0 0 0 0.631373 0 0 0 0.1 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_72473_44681"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="2.76923" />
                <feGaussianBlur stdDeviation="1.38462" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.631373 0 0 0 0 0.631373 0 0 0 0 0.631373 0 0 0 0.09 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_dropShadow_72473_44681"
                  result="effect2_dropShadow_72473_44681"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="6.23077" />
                <feGaussianBlur stdDeviation="2.07692" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.631373 0 0 0 0 0.631373 0 0 0 0 0.631373 0 0 0 0.05 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect2_dropShadow_72473_44681"
                  result="effect3_dropShadow_72473_44681"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="11.7692" />
                <feGaussianBlur stdDeviation="2.42308" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.631373 0 0 0 0 0.631373 0 0 0 0 0.631373 0 0 0 0.01 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect3_dropShadow_72473_44681"
                  result="effect4_dropShadow_72473_44681"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect4_dropShadow_72473_44681"
                  result="shape"
                />
              </filter>
              <linearGradient
                id="paint0_linear_72473_44681"
                x1="15.3846"
                y1="12.0769"
                x2="56.2308"
                y2="46"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FF576D" />
                <stop offset="1" stopColor="#FB913A" />
              </linearGradient>
              <clipPath id="clip0_72473_44681">
                <rect width="20" height="20" fill="white" transform="translate(13 9)" />
              </clipPath>
            </defs>
          </svg>
        );
      case Icons.CLOSE:
        return (
          <svg
            width="46"
            height="54"
            viewBox="0 0 46 54"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_dddd_72473_44712)">
              <rect x="5" y="1" width="36" height="36" rx="12" fill="#FEF1E6" />
              <rect
                x="5.75"
                y="1.75"
                width="34.5"
                height="34.5"
                rx="11.25"
                stroke="url(#paint0_linear_72473_44712)"
                strokeWidth="1.5"
              />
              <g clipPath="url(#clip0_72473_44712)">
                <path
                  d="M28 14L18 24"
                  stroke="#262626"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M18 14L28 24"
                  stroke="#262626"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <defs>
              <filter
                id="filter0_dddd_72473_44712"
                x="-1.92308"
                y="-5.92308"
                width="49.8462"
                height="59.5385"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="0.692308" />
                <feGaussianBlur stdDeviation="0.692308" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.631373 0 0 0 0 0.631373 0 0 0 0 0.631373 0 0 0 0.1 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_72473_44712"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="2.76923" />
                <feGaussianBlur stdDeviation="1.38462" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.631373 0 0 0 0 0.631373 0 0 0 0 0.631373 0 0 0 0.09 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_dropShadow_72473_44712"
                  result="effect2_dropShadow_72473_44712"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="6.23077" />
                <feGaussianBlur stdDeviation="2.07692" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.631373 0 0 0 0 0.631373 0 0 0 0 0.631373 0 0 0 0.05 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect2_dropShadow_72473_44712"
                  result="effect3_dropShadow_72473_44712"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="11.7692" />
                <feGaussianBlur stdDeviation="2.42308" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.631373 0 0 0 0 0.631373 0 0 0 0 0.631373 0 0 0 0.01 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect3_dropShadow_72473_44712"
                  result="effect4_dropShadow_72473_44712"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect4_dropShadow_72473_44712"
                  result="shape"
                />
              </filter>
              <linearGradient
                id="paint0_linear_72473_44712"
                x1="15.3846"
                y1="12.0769"
                x2="56.2308"
                y2="46"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FF576D" />
                <stop offset="1" stopColor="#FB913A" />
              </linearGradient>
              <clipPath id="clip0_72473_44712">
                <rect width="20" height="20" fill="white" transform="translate(13 9)" />
              </clipPath>
            </defs>
          </svg>
        );

      default:
        return null;
    }
  };
  return (
    <div className={className} style={{ display: 'flex' }}>
      {renderIcon()}
    </div>
  );
};

Icons.OPEN = 'Open';
Icons.CLOSE = 'Close';
